import {Button} from 'react-native-paper';
import PropTypes from 'prop-types';

const ActionButton = ({style, children, disabled, onPress}) => {
  return (
    <Button
      style={style}
      labelStyle={{marginHorizontal: 8}}
      disabled={disabled}
      onPress={onPress}>
      {children}
    </Button>
  );
};
ActionButton.propTypes = {
  style: PropTypes.any,
  children: PropTypes.any,
  disabled: PropTypes.any,
  onPress: PropTypes.any,
};


export default ActionButton;
